export default __webpack_public_path__ + "static/media/companyLogo5.d12728f6.png";